import { useContext } from 'react';
import { IbgeContext } from '../contexts/IbgeContext';

export function useIbge() {
  const value = useContext(IbgeContext);

  return value;
}
